// extracted by mini-css-extract-plugin
export default {"tocContainer":"styles_tocContainer__AY9Fo","icon":"styles_icon__otUud"};